<template>
    <base-nav  class="navbar-top navbar-dark hidden__colapse justify-content-center" id="navbar-main" :show-toggle-button="false" expand>
        <div class="navbar-nav float-right d-flex ml-auto nav__item">
            <div class="nav-item dropdown d-inline-flex">
                    <!-- <div class="input-search" >
                        <button class=""><i class="fa fa-search" aria-hidden="true"></i></button>
                        <input type="text" class="form-control search rounded-circle" placeholder="Rechercher un patient">
                    </div>
                <div class="nav-link d-flex ">
                    <div class="">
                        <span class="dropdown-item dropdown__content ml-3">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" width="22px"
                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                            </svg>
                        </span>
                    </div>
                    <div class="">
                        <span class="dropdown__content ml-3">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" width="22px" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>

                             <span>{{ $t('message.settings') }}</span> 
                        </span>
                    </div> 
                </div>  -->
                <!--Notification section -->
                <div @click="open = !open" class="d-flex align-items-center">
                    <div class="notification position-bell p-0">
                        <li v-if="count!=0" class="list-none cursor-pointer notification-num  px-1 py-1">{{ count }}</li>
                        <p class="notification-icon border p-2 m-0 rounded-circle cursor-pointer">
                            <i class="fa fa-bell"></i>
                        </p>
                    </div>
                </div>
                <Transition name="bounce" class=" mt-5">
                    <div v-if="open" class="notification-content px-4 py-2 shadow mt-4" @click="open = true">
                        <NotificationCard :openNotif="open"/>
                    </div>
                </Transition>
                <base-dropdown class="nav-link">
                    <div class="media " slot="title">
                        <!-- <div class="mt--2">
                            <span class="badge badge-danger bg-white ml-2">4</span>
                            <h3><i class="fa fa-bell"></i></h3></div> -->
                        <div class="mt-2 mr-3 ml-3">
                            <button
                                :class="{ 'nav-item': true, '': true, 'isLangActive': getLocalLanguage == 'fr', 'lang-style': true }"
                                @click="setUserLanguage('fr')">
                                <span v-if="getLocalLanguage == 'fr'">FR</span>
                                <span v-else>EN</span>
                            </button>
                        </div>
                    </div>
                    <template>
                        <button
                            :class="{ 'nav-item': true, 'ml-1': true, 'isLangActive': getLocalLanguage == 'en', 'lang-style': true }"
                            @click="setUserLanguage('en')">
                            <span v-if="getLocalLanguage == 'en'">EN</span>
                            <span>EN</span>
                        </button>
                    </template>
                </base-dropdown>

                <base-dropdown class="nav-link mr-0">
                    <div class="media" slot="title">
                        <div class="">
                            <span class="dropdown-item content__info d-flex align-items-center justify-content-between">
                                <span class="dropdown__content"> {{ getFirstLetters(user.nom)}} </span>
                                <span class="d-none d-sm-block">{{ user.name }}</span>
                                <span ><i class="fa fa-caret-down" aria-hidden="true"></i></span>
                            </span>
                        </div>
                    </div>

                    <template class="">
                       <div class="position-absolute bg-white p-1 right--3 dropdown-menu--shadow">
                            <b-link class="dropdown-item">
                                <span>{{ user.name }}</span>
                            </b-link>
                            <router-link class="dropdown-item" to="/user-info">
                                <i class="ni ni-circle-08"></i>
                                <span>{{ $t('message.account') }}</span>
                            </router-link>
                            <router-link class="dropdown-item" to="/signature">
                                <i class="fa fa-signature" aria-hidden="true"></i>
                                <span>{{ $t('message.signature') }}</span>
                            </router-link>
                            <b-link class="dropdown-item" @click="logOut">
                                <i class="ni ni-button-power text-warning"></i>
                                <span style="color:red">{{ $t('message.logout') }}</span>
                            </b-link>
                            <!-- <div>
                                <a class="dropdown-item btn btn-danger my-2" style="color:red" @click="logOut">
                                    <i class="ni ni-button-power"></i>
                                    <span style="color:red">{{ $t('message.logout') }}</span>
                                </a>
                            </div> -->
                            <!-- <div class="">
                                <span class="dropdown-item content__info d-flex align-items-center justify-content-between">
                                    <span>{{ user.name }}</span>
                                </span>
                            </div> -->
                       </div>
                    </template>
                </base-dropdown>
            </div>
        </div>
    </base-nav>
</template>
<script>
import NotificationCard from "./NotificationCard";
import NotificationInfo from "./NotificationInfo.vue";
import NotificationDetails from "./NotificationDetails.vue";
import AppConfig from '../constants/AppConfig';
import { mapGetters } from 'vuex';
import Vue from 'vue';
import i18n from "../plugins/i18n";

export default {
    components: {
        NotificationCard,
        NotificationInfo
    },
    computed: {
        ...mapGetters(["notificationCount", 'hasAdminRole']),

        count: function () {
            return this.notificationCount == undefined ? 0 : this.notificationCount;
        },
        getLocalLanguage: function () {
            return this.$i18n.locale;
        }
    },

    data() {
        return {
            open: false,
            langs: ['fr', 'en'],
            activeNotifications: false,
            //avatar: AppConfig.baseUrl + '/img/theme/team-4-800x800.jpg',
            avatar: AppConfig.baseUrl + '/img/theme/default-user.png',
            showMenu: false,
            searchQuery: '',
            user: JSON.parse(localStorage.getItem('user')),
            role: localStorage.getItem('role'),
            dashboardName: localStorage.getItem("dashboardName"),
            size: 25,
            animated: true,
            ShowSearch: false,
        };
    },
    methods: {
        getFirstLetters(str) {
            const firstLetters = str
                .split(' ')
                .map(word => word[0])
                .join('');

            return firstLetters;
        },
        setUserLanguage(langue) {
            i18n.locale = langue;
            this.$cookies.remove("userLanguage");
            var a = new Date();
            a = new Date(a.getTime() + 9999 * 60 * 60 * 24 * 365);
            document.cookie = 'userLanguage=' + langue + "; expires=" + a.toUTCString() + ";secure";
        },

        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },

        igetWidth: function (){
            if(window.innerWidth > 420){
                return true;
            }
            return false;
        },

        hideSidebar() {
            this.$sidebar.displaySidebar(false);
        },
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        logOut() {
            let args = {
                // user: localStorage.getItem('user')
            };

            let successMessage = this.$i18n.t('message.logoutSuccess');
            let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
            };
            this.$store.dispatch('logoutHandler', { args, errorMessages, successMessage });
        },
        mounted() {

        }
    },
};
</script>
